import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { login, selectApp } from 'src/actions';

const useRestoreAuthDetails = () => {
  const dispatch = useDispatch();

  const app = localStorage.getItem('@kupos_admin_app')
    ? localStorage.getItem('@kupos_admin_app')
    : null;

  const user = localStorage.getItem('@kupos_admin_user')
    ? JSON.parse(localStorage.getItem('@kupos_admin_user'))
    : null;

  const isLoggedIn = user && app;

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(login(user));
      dispatch(selectApp(app));
    }
  }, [isLoggedIn, dispatch, app, user]);

  return null;
};

export default useRestoreAuthDetails;
